<c11n-button [buttonType]="'button'"
             [id]="'buy-btn'" [size]="size"
             [variant]="'primary'"
             [labelText]="'Buy'"
             [ariaLabelText]="'Buy ' + fundInput.fundName"
             (clickEvent)="buyFunds()">
</c11n-button>
